import React, { useState, useEffect } from 'react';
import './SnackbarSidebar.css'; // Create a CSS file for styling

import snackbarBottom from "./snackbarBottom.png";
import {Check,X} from 'lucide-react';
const SnackbarSidebar = ({ message, color,onClose }) => {
  const [visible, setVisible] = useState(false);
  const [animate, setAnimate] = useState(false);
  useEffect(() => {
    // Trigger the animation after a delay (e.g., 500ms)
    const timer = setTimeout(() => {
     setAnimate(true);  
   }, 100);
 
    return () => clearTimeout(timer); // Cleanup on unmount
  }, []);
 
  useEffect(() => {
    setVisible(true);

    // Hide snackbar after 3 seconds
    const timer = setTimeout(() => {
      setVisible(false);
      onClose();
    }, 3000);

    return () => clearTimeout(timer);
  }, [onClose]);

  const handleClick = () => {
    setVisible(false);
    onClose();
  };

  return ( <div   style={{zIndex:999999999} }>
   
    <div className={`snackbar-sidebar ${visible ? 'show' : ''}`} style={{"textAlign":"center",
        // bottom: animate ? '120px' : '0px',
        opacity: animate ? 1 : 0,
         color:color,
        // border:"2px dashed "+color,
        color:"#222",
        transition: 'bottom 1s ease, opacity 1s ease',
      }} onClick={handleClick}>
       
         {message}
        
         <img src={snackbarBottom} alt="" style={{position:'absolute',width:"100%",bottom:"0px",left:"0px",right:"0px",}} />
       
    </div>
 
    </div>
  );
};

export default SnackbarSidebar;
